import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { Question } from 'utils';

type ReturnType = Promise<AxiosResponse>;

interface updateFormSectionPayload {
    name: string;
    media?: string | null;
    description?: string | null;
    questions: Array<Question>;
}

const updateFormSection = (
    formId: string,
    sectionId: string,
    payload: updateFormSectionPayload,
): ReturnType => {
    return Request.put(`/data/forms/${formId}/sections/${sectionId}`, payload);
};

export default updateFormSection;
